import React from 'react'
import {
    makeStyles,
    useMediaQuery,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab"
import theme from "js/material-ui-theme"
import { useTranslation } from 'react-i18next'

interface EmptyListNewAlertProps {
    translation: string
}

/**
 * Componente de alerta lista vazia
 *
 * *  Crie um objeto com o nome da entidade com useTranslation
 * *  O objeto deve conter o objeto abaixo
 * *  
 * "messagesAlert": {
            "newType": "Nova Comissão",
            "newRegister": "para cadastrar sua primeira Comissão!",
    },
*
* *  O Componente recebe como prop somente com nome do objeto Entidade

 */

export function EmptyListNewAlert({ translation }: EmptyListNewAlertProps) {
    const { t } = useTranslation([translation, 'common'])
    const matches = !useMediaQuery(theme.breakpoints.down('xs'));
    const styles = useStyles();
    return (

        <Alert severity="info" className={styles.emptyListInfo}>
            {t('Alert.New.click') + " "}
            {
                matches ? (
                    <span>
                        {t('Alert.New.in')} <strong> {t('messagesAlert.newType').toUpperCase()} </strong>
                    </span>
                ) : (
                    <strong> {t('Alert.New.onTheButton').toUpperCase()}</strong>
                )
            }
            {t('messagesAlert.newRegister')}
        </Alert>

    )
}

const useStyles = makeStyles(() => ({
    emptyListInfo: { marginBottom: theme.spacing(3) }
}));
